<template>

  <b-modal id="UsuarioAdminUpdate" size="md" ref="modal" centered no-close-on-backdrop hide-footer>

    <template slot="modal-header">
      <h5 class="modal-title">Actualización de Datos</h5>
    </template>

    <template slot="default" slot-scope="{ hide }">

      <b-form class="final_form" @submit.stop.prevent="editar" ref="form">

        <div class="final_form_container">

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Email</label>
              <label class="inputReadonly">{{ usuario.mail }}<i class="fa fa-lock input_end_icon"></i></label>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Nombres</label>
              <b-form-input class="inputText" v-model="usuario.nombre" type="text" autofocus="autofocus" required :disabled="loading"></b-form-input>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Apellidos</label>
              <b-form-input class="inputText" v-model="usuario.apellido" type="text" required :disabled="loading"></b-form-input>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Zona Horaria</label>
              <treeselect class="inputRelation required" v-model="usuario.time_zone" :clearable="false" :disable-branch-nodes="true" placeholder="" 
              :disabled="loading" required :options="time_zones" :auto-load-root-options="false" :cache-options="false" :open-on-focus="true"/>
          </div>

         </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
        </div>

      </b-form>

    </template>

  </b-modal>

</template>

<script>

import router from '../../../router'
import Treeselect from '../../utils/vue-treeselect/src/components/Treeselect'
import moment from 'moment'

export default {
  components: {
    Treeselect
  },
  data () {
    return {
      loading: false,
      usuario: {
        userid: '',
        nombre: '',
        apellido: '',
        mail: '',
        error: ''
      },
      time_zones : [
        { label: 'America/Asuncion', id: 'America/Asuncion' },
        { label: 'America/Bogota', id: 'America/Bogota' },
        { label: 'America/Buenos_Aires', id: 'America/Buenos_Aires' },
        { label: 'America/Guayaquil', id: 'America/Guayaquil' },
        { label: 'America/La_Paz', id: 'America/La_Paz' },
        { label: 'America/Lima', id: 'America/Lima' },
        { label: 'America/Montevideo', id: 'America/Montevideo' },
        { label: 'America/New_York', id: 'America/New_York' },
        { label: 'America/Santiago', id: 'America/Santiago' },
        { label: 'US/Alaska', id: 'US/Alaska' },
        { label: 'US/Arizona', id: 'US/Arizona' },
        { label: 'US/Central', id: 'US/Central' },
        { label: 'US/Hawaii', id: 'US/Hawaii' },
        { label: 'US/Pacific', id: 'US/Pacific' },
        { label: 'US/Samoa', id: 'US/Samoa' },
        { label: 'Universal', id: 'Universal' },
      ],
    }
  },
  mounted () {
    try {
        if (!localStorage.signedIn) {
          this.$router.push('/')
        } else {
          this.usuario.id = localStorage.id;

          this.loading = true

          this.getUsuarioForUpdate(this.usuario.id)
          .then(data => {
            this.usuario = data.usuario
            this.usuario.time_zone = undefined
            this.loading = false
          })

          
        } 
      } catch (error) {
        this.loading = false
        this.showError(error)
      }
  },
  methods: {
    editar () {
      try {

        this.loading = true

        var params = { 
          v2_usuario: { 
            nombre: this.cs(this.usuario.nombre), 
            apellido: this.cs(this.usuario.apellido), 
            time_zone: this.usuario.time_zone
          }
        }

        this.$http.secured.patch(`/auth/v1/users/${this.usuario.id}`, params)  
          .then(response => {
            this.loading = false

            localStorage.time_zone = this.usuario.time_zone

            localStorage.nombre = this.usuario.nombre
            localStorage.apellido = this.usuario.apellido

            localStorage.setItem("userinfo", JSON.stringify({
                displayName : this.usuario.nombre + " " + this.usuario.apellido
            }));

            moment.tz.setDefault(this.usuario.time_zone);

            this.showOK("Se actualizó el usuario correctamente!")
            this.$emit('closeModal')
            this.$refs.modal.hide()
            this.$router.replace('/')
          })
          .catch(error => {
            this.loading = false
            this.showError(error)
          })

      } catch (error) {
        this.loading = false
        this.showError(error)
      }
    }
  }
}
</script>
